import React from "react"
import MinimalPortfolio from "@openarchitex/gatsby-theme-minimal-portfolio/src/templates/minimal-portfolio";
import 'bootstrap/dist/css/bootstrap.min.css';
export default function Home() {
  return <MinimalPortfolio />
}
